import React from 'react'
import {
  NavigationContainer,
  LeftSection,
  SectionsWrapper,
  SpaceFiller,
  MiddleSection,
  RightSection,
} from './style'
import BreadCrumbs from '@components/BreadCrumbs'
import { useBreadcrumbs } from '@hooks/useBreadcrumbs'

const SubHeader = (props) => {
  const { breadcrumb, children } = props

  useBreadcrumbs(breadcrumb)

  return (
    <>
      <nav className={NavigationContainer}>
        <div className={SectionsWrapper}>
          <div className={LeftSection}>
            <BreadCrumbs />
          </div>

          {children}
        </div>
      </nav>
      <div className={SpaceFiller} />
    </>
  )
}

SubHeader.MiddleSection = ({ children }) => (
  <div className={MiddleSection}>{children}</div>
)

SubHeader.RightSection = ({ children }) => (
  <div className={RightSection}>{children}</div>
)

export default SubHeader
